// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__BackInStock-Subscription .pfs-feature-lock-card,
.BC-Page__BackInStock-Settings .pfs-feature-lock-card {
  margin: unset;
  padding: 40px 93px;
}

.BC-BISSettingsGuide .Polaris-Banner {
  margin-bottom: 32px;
}
.BC-BISSettingsGuide .Polaris-Banner .Polaris-Link {
  display: inline-flex;
  gap: 2px;
  color: #2c6ecb;
}

.BC-BISSettingsGuide .setup-content .non-action .Polaris-Icon,
.BC-BISSettingsGuide .Polaris-Banner .Polaris-Icon {
  margin: unset;
  width: 15px;
  height: 15px;
}

.BC-BISSettingsGuide .Polaris-Grid {
  gap: 20px;
}

.BC-BISSettingsGuide .setup-content .action,
.BC-BISSettingsGuide .setup-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-BISSettingsGuide .setup-content .non-action {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__BackInStock-Settings .Polaris-Card .title .Polaris-Label__Text,
.BC-Page__BackInStock-Settings .Polaris-Card .title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Back in stock - settings */
.BC-Page__BackInStock-Settings .Polaris-Card .title .badge-info {
  background-color: #e0f0ff;
  border-radius: 8px;
  padding: 2px 8px;
  align-items: center;
  display: flex;
  justify-content: center;
  color: #00527c;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
}

.BC-Page__BackInStock-Settings .Polaris-PageActions {
  border-top: none;
}

.BC-Page__BackInStock-Settings .BC-Toggle-Switch .tooltip {
  margin-top: 4px;
  margin-left: 4px;
}

.BC-Page__BackInStock-Settings .Polaris-Tabs__Panel {
  padding: 16px 0;
}

.BC-Page__BackInStock-Settings .notification-usages {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-Page__BackInStock-Settings .notification-settings .pfs-feature-lock-card img {
  width: 160px;
  height: auto;
}

.BC-Page__BackInStock-Settings .notification-settings .pfs-feature-lock-card {
  padding: 92px 112px;
}

.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle > div {
  display: flex;
  flex-direction: column;
  gap: 4;
}

.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle p:first-child {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle .tag {
  padding: 2px 8px;
  background: #cdfee1;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #0c5132;
}

.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle .tag-off {
  background: #d6d6d6;
  color: #616161;
}

.BC-Page__BackInStock-Settings .notification-usages .header {
  display: flex;
  justify-content: space-between;
}

.BC-Page__BackInStock-Settings .notification-usages .header > p {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__BackInStock-Settings .notification-usages .header > div {
  border-radius: 8px;
  padding: 2px 8px;
  background-color: #e0f0ff;
  color: #00527c;
}

.BC-Page__BackInStock-Settings .notification-usages .upgrade {
  color: #2c6ecb;
  align-items: center;
}

.BC-Page__BackInStock-Settings .notification-usages .upgrade:hover {
  cursor: pointer;
  text-decoration: underline;
}

.BC-Page__BackInStock-Settings .notification-usages .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
  width: 14px;
  height: 14px;
  margin-left: 2px;
  margin-top: 3px;
}

.BC-Page__BackInStock-Settings .usages-exceed .header > div {
  background-color: #fedad9;
  color: #8e1f0b;
}

.BC-Page__BackInStock-Settings .usages-exceed .warning {
  display: flex;
  gap: 8px;
  padding: 10px 16px;
  background-color: #fffbf3;
  border-radius: 8px;
}

.BC-Page__BackInStock-Settings .usages-exceed .warning > div {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BC-Page__BackInStock-Settings .usages-exceed .warning .Polaris-Button {
  background-color: #ffc96b;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
}

.BC-Page__BackInStock-Settings .usages-exceed .warning .Polaris-Button__Text {
  font-weight: 500;
}

.BC-Page__BackInStock-Settings .customize-email .title {
  padding: 18px 16px;
  font-weight: 500;
  font-size: 16px;
  border-bottom: 1px solid #e1e3e5;
}
.BC-Page__BackInStock-Settings .customize-email .settings {
  display: flex;
}

.BC-Page__BackInStock-Settings .customize-email .settings .domain-field {
  display: flex;
  gap: 16px;
  align-items: start;
}

.BC-Page__BackInStock-Settings .customize-email .settings .domain-field .action {
  display: flex;
}

.BC-Page__BackInStock-Settings .customize-email .settings .domain-field > div:first-child {
  width: 100%;
}

.BC-Page__BackInStock-Settings .customize-email .Polaris-Tabs__Panel {
  padding: 16px;
}
.BC-Page__BackInStock-Settings .customize-email .Polaris-Tabs__Panel:has(.customize-email-tab) {
  padding-right: 0;
}

.BC-Page__BackInStock-Settings .customize-email .Polaris-Scrollable {
  scrollbar-width: none;
}

/* Show scrollbar only on hover */
.BC-Page__BackInStock-Settings .customize-email .Polaris-Scrollable:hover {
  scrollbar-width: thin;
  scroll-margin-left: 2px;
}

.BC-Page__BackInStock-Settings .customize-email .preview {
  width: 50%;
  border-left: 1px solid #e1e3e5;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template {
  padding: 12px;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template > div {
  padding: 17px 12px;
  border-radius: 6px;
  background-color: #f1f1f1;
  position: relative;
  height: 100%;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template img {
  width: 177px;
  height: auto;
  margin-top: 16px;
  margin-bottom: 20px;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template > div > div:first-child {
  background-color: #ffff;
  padding: 24px 20px;
  text-align: center;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template > div h2 {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  margin-top: 8px;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template > div > div:first-child p {
  font-size: 10px;
  line-height: 15px;
  margin-top: 16px;
}

.BC-Page__BackInStock-Settings .customize-email .preview-box-mail-action {
  width: 100%;
  position: absolute;
  bottom: 6px;
  display: flex;
  justify-content: center;
}

.BC-Page__BackInStock-Settings .customize-email .preview-box-mail-action > div {
  padding: 4px 8px;
  border: 1px solid #98c6cd;
  background-color: #ebf9fc;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 0px 2px 0px #00000033;
  gap: 50px;
}

.BC-Page__BackInStock-Settings .customize-email .preview-box-mail-action > div > p:nth-child(2) {
  color: #2c6ecb;
  cursor: pointer;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template > div .btn {
  display: flex;
  justify-content: center;
}

.BC-Page__BackInStock-Settings .customize-email .preview-template > div .btn > div {
  padding: 8px 16px;
  border-radius: 2px;
  margin-top: 16px;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 16px;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .label {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 4px;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .waring-from-address {
  padding: 16px;
  border-radius: 4px;
  background: #fff5ea;
  border: 1px solid #e1b878;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .label > p:nth-child(2) {
  cursor: pointer;
  color: #2c6ecb;
  height: 20px;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .row {
  display: flex;
  gap: 12px;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .row > div {
  width: 50%;
}

.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .divider {
  margin: 4px 0;
}

.BackInStock-LiquidVariablesModal {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BackInStock-LiquidVariablesModal > div {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
  align-items: center;
}

.BC-Page__BackInStock-Settings
  .customize-email
  .BC-Page__BackInStock-Settings
  .customize-email
  textarea {
  background-color: #fafbfb;
}

.BC-Page__BackInStock-Settings .customize-email .html-template {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 12px;
  height: 486px;
}

.BC-Page__BackInStock-Settings .customize-email .html-template .preview-box-mail-action {
  z-index: 50;
}

.BC-Page__BackInStock-Settings .customize-email .html-template textarea {
  border: 1px solid #d0d0d0;
  background-color: #fafbfb;
  max-height: 455px;
  height: 455px;
  font-family: Monaco;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
}

.BC-Page__BackInStock-Settings .customize-email .domain-settings {
  min-height: 486px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 6px;
  color: #916a00;
}
.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-success {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 6px;
  color: #008060;
}

.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-warning .Polaris-Icon,
.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-success .Polaris-Icon {
  margin: unset;
  width: 16px;
  height: 16px;
}

.BC-Page__BackInStock-Settings .customize-email .domain-settings > div {
  background-color: #fafbfb;
  padding: 12px 16px;
}

.BIS-DomainTable {
  padding: 8px 12px;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BIS-DomainTable .row {
  display: flex;
  gap: 4px;
}

.BIS-DomainTable .headings > p {
  font-weight: 600;
}

.BIS-DomainTable .row > p {
  width: calc(100% / 3);
}

.BC-Page__BackInStock-Settings .display-settings .tooltip {
  margin-top: 7px !important;
  margin-left: 8px;
}

.BC-Page__BackInStock-Settings .Polaris-Card__Section > .Polaris-TextStyle--variationSubdued {
  margin-top: 4px;
}

.BC-Page__BackInStock-Settings .product-settings {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BC-Page__BackInStock-Settings .product-settings .Polaris-Choice .tooltip {
  margin-top: unset;
}

.BC-Page__BackInStock-Settings .product-settings .item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-Page__BackInStock-Settings .product-settings .item > div:nth-child(2) {
  margin-left: 28px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-Page__BackInStock-Settings .BC-Draggable__Tag {
  padding-right: 0;
}

.BC-Page__BackInStock-Settings .display-settings .title {
  padding: 16px 20px;
  border-bottom: var(--p-border-divider);
}

.BC-Page__BackInStock-Settings .display-settings .content {
  display: flex;
}

.BC-Page__BackInStock-Settings .display-settings .content > div {
  width: 50%;
}

.BC-Page__BackInStock-Settings .display-settings .content > div:first-child {
  border-right: var(--p-border-divider);
}

.BC-Page__BackInStock-Settings .preview > div,
.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel {
  padding: 16px 20px;
}

.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel {
  min-height: 441px;
}

.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel .row {
  display: flex;
  gap: 8px;
}

.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel .row > div {
  flex: 1;
}

.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel > div {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.BC-Page__BackInStock-Settings .Polaris-Tabs__Wrapper {
  padding: 0 20px;
  padding-top: 4px;
}

.BC-Page__BackInStock-Settings .preview > div:nth-child(1) {
  border-bottom: var(--p-border-divider);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.BC-Page__BackInStock-Settings .preview .view {
  padding: 16px;
  width: 100%;
  height: 100%;
}

.BC-Page__BackInStock-Settings .preview .view > div {
  background-color: #f1f1f1;
  border-radius: 8px;
  width: 100%;
}

.BC-Page__BackInStock-Settings .preview .view .button-settings {
  position: relative;
  padding: 23px 14px 0;
}

.BC-Page__BackInStock-Settings .preview .view .btn-preview-container {
  position: absolute;
  right: 0;
  top: 40px;
  min-width: 44px;
  min-height: 280px; /* The height of the btn-preview */
}

.BC-Page__BackInStock-Settings .preview .view .btn-preview-inline {
  border-radius: 4px;
}

.BC-Page__BackInStock-Settings .preview .view .btn-preview-inline,
.BC-Page__BackInStock-Settings .preview .view .btn-preview {
  text-align: center;
  padding: 12px 20px;
  min-width: 280px; /* Width becomes height after rotation */
}

.BC-Page__BackInStock-Settings .preview .view .btn-preview {
  position: absolute;
  top: 0;
  right: 44px;
  border-radius: 4px 4px 0 0;
  transform: rotate(-90deg);
  max-width: 334px;
  height: 44px; /* Height becomes width after rotation */
  transform-origin: top right; /* Ensure rotation doesn't affect position */
}

.BC-Page__BackInStock-Settings .preview .view .btn {
  width: 100%;
  border-radius: 4px;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #cccccc;
  background: #fafafa;
  color: #cecece;
}

.BC-Page__BackInStock-Settings .preview .blocks {
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.BC-Page__BackInStock-Settings .preview .view > div > div {
  background-color: #ffff;
  min-height: 360px;
}

.BC-Page__BackInStock-Settings .preview .blocks .col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BC-Page__BackInStock-Settings .preview .view .signup-form {
  padding: 10px 15px;
}
.BC-Page__BackInStock-Settings .preview .view .signup-form > div {
  border-radius: 8px;
  height: auto;
}

.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-content {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}

.BC-Page__BackInStock-Settings .preview .signup-form .modal-content .phone-input-preview {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-Page__BackInStock-Settings .preview .signup-form .modal-content .phone-input-preview > div {
  display: flex;
  align-items: center;
  border: 1px solid #c9cccf;
  border-radius: 4px;
  padding: 8px 12px;
}

.BC-Page__BackInStock-Settings .preview .view .signup-form > div > div:nth-child(1) {
  border-bottom: var(--p-border-divider);
}

.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-title {
  font-size: 18px;
  line-height: 28px;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  height: auto;
}

.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-title > p {
  width: 70%;
  max-width: 70%;
  height: 100%;
}

.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-title .Polaris-Icon {
  margin: unset;
  width: 20px;
  height: 20px;
}

.BC-Page__BackInStock-Settings .preview .view .signup-form .action {
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 4px;
  margin-top: 20px;
}

.BC-Page__BackInStock-Settings .preview .view .confirmation-message {
  padding: 0 17px;
  height: auto;
}

.BC-Page__BackInStock-Settings .preview .view .confirmation-message .blocks {
  padding: 0 40px 18px;
}

.BC-Page__BackInStock-Settings .selectedColor {
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  margin-left: 0.75rem;
  cursor: pointer;
}
.BC-Page__BackInStock-Settings .preview .view .confirmation-message .notify-banner {
  margin: 0 20px;
  padding: 12px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.BC-Page__BackInStock-Settings .preview .view .confirmation-message .notify-banner .icon {
  border-radius: 100%;
  width: 20px;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-Page__BackInStock-Settings .notification-settings .button-large.isSelected .Polaris-Button,
.BC-Page__BackInStock-Settings .notification-settings .button-large:hover .Polaris-Button {
  border: 1px solid #2c6ecb;
}

.BC-Page__BackInStock-Settings
  .notification-settings
  .button-large:hover
  .Polaris-Button.Polaris-Button--disabled {
  border-color: var(--p-border-disabled);
}

.BC-Page__BackInStock-Settings .notification-settings .button-large .Polaris-Button {
  padding: 1rem;
}

.BC-Page__BackInStock-Settings .notification-settings .button-large .button-content {
  display: flex;
  align-items: center;
}

.BC-Page__BackInStock-Settings .notification-settings .button-large .button-content .Polaris-Badge {
  padding: 2px 8px;
  height: fit-content;
}

.BC-Page__BackInStock-Settings
  .notification-settings
  .Polaris-Card__Section
  .notification-setting-steps {
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  background: var(--p-background, #f6f6f7);
  border-radius: 0.25rem;
}

.BC-Page__BackInStock-Settings
  .notification-settings
  .Polaris-Card__Section
  .notification-setting-steps:last-child {
  margin-bottom: 0;
}

.BC-Page__BackInStock-Settings .notification-settings .notification-setting-steps p:first-child {
  margin-bottom: 0.25rem;
}

.BC-Page__BackInStock-Settings .notification-settings .notification-setting-steps ul {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 1.5rem;
}

.blocks .rectangle-lg {
  width: 227px;
  height: 36px;
  border-radius: 4px;
  background-color: #f0f0f0;
}

.blocks .rectangle {
  border-radius: 4px;
  background-color: #f0f0f0;
}

.blocks .group {
  display: flex;
  gap: 8px;
}

.blocks .rounded {
  border-radius: 20px;
  background-color: #f0f0f0;
}

.blocks .rounded-md {
  width: 80px;
  height: 36px;
}

.blocks .rectangle-lg {
  width: 227px;
  height: 36px;
}

.blocks .rectangle-mn {
  height: 14px;
  width: 227px;
}

.blocks .rectangle-md {
  width: 103px;
  height: 28px;
}

.blocks .rectangle-sm {
  width: 71px;
  height: 20px;
}

/* Back in stock - subscriptions */
.BC-Page__BackInStock-Subscription .Polaris-DataTable__Cell--actions .Polaris-Icon svg {
  fill: var(--p-icon);
}

.BC-Page__BackInStock-Subscription .Polaris-Tabs__Panel .Polaris-Card {
  margin-top: 24px;
}

.BC-Page__BackInStock-Subscription .Polaris-Tabs__Wrapper {
  width: 100%;
}

.BC-Page__BackInStock-Subscription .Polaris-DataTable__Cell--subscriber {
  max-width: 22%;
}

.BC-Page__BackInStock-Subscription .Polaris-DataTable__Cell > p {
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: normal;
}

.BC-Page__BackInStock-Subscription .Polaris-Tabs__TabContainer:first-child {
  max-width: 120px;
}

.BC-Page__BackInStock-Subscription .filter-days {
  display: flex;
  gap: 6px;
  align-items: center;
}

.BC-Page__BackInStock-Subscription .filter-days .Polaris-Icon {
  margin: unset;
}

.BC-Page__BackInStock-Subscription .subscribed-actions,
.BC-Page__BackInStock-Subscription .submissions-actions {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 24px;
}

.BC-Page__BackInStock-Subscription
  .list-submissions
  .Polaris-DataTable__Cell--header
  .Polaris-Icon {
  margin: unset;
  cursor: pointer;
}

.BC-BIS__FilterDays {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 2px;
}

.BC-Page__BackInStock-Subscription .BC-Filters {
  padding: 20px;
  border-bottom: var(--p-border-divider);
}

.BC-Page__BackInStock-Subscription nav {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.BC-Page__BackInStock-Subscription .BC-Filters__TagsContainer {
  padding-top: 10px;
}

/* ------ submissions ------- */
.BC-EmptySearch__BackInStockSubscription {
  text-align: center;
  padding: 80px 112px;
}

.BC-EmptySearch__BackInStockSubscription img {
  max-width: 45px;
  height: auto;
  margin-bottom: 16px;
}

.BC-Page__BackInStock-NewSubscriber .Polaris-Page-Header__Row {
  padding: 20px 0;
  border-bottom: var(--p-border-divider);
}

.BC-Page__BackInStock-NewSubscriber .Polaris-Header-Title > div {
  display: flex;
  gap: 16px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  align-items: center;
}

.BC-Page__BackInStock-NewSubscriber .Polaris-Page > div:nth-child(2) {
  margin-top: 24px;
}
.BC-Page__BackInStock-NewSubscriber .Polaris-Header-Title > div button {
  background-color: unset;
}

.BC-Page__BackInStock-NewSubscriber .Polaris-Card__Header {
  border-bottom: var(--p-border-divider);
  padding: 16px 20px;
}

.BC-Page__BackInStock-NewSubscriber .BC-SelectedProductsField .product-item {
  border: 0.1rem dashed #e1e3e5;
  border-radius: 8px;
  align-items: center;
  text-align: center;
  padding: 8px 16px;
}

.BC-Page__BackInStock-NewSubscriber .BC-SelectedProductsField .product-item__Action {
  display: flex;
}

.BC-Page__BackInStock-NewSubscriber .BC-SelectedProductsField .Polaris-Icon svg {
  fill: #8c9196;
}

/* ------ products ------- */
.BC-BISSubscription--Filters {
  display: flex;
  gap: 8px;
}

.BC-BISSubscription--Filters > .search {
  flex: 1;
}

.BC-BackInStockFilters--Popover .Polaris-ChoiceList .Polaris-ChoiceList__Title {
  font-weight: 500;
}

.BC-BackInStockFilters--Popover .Polaris-ChoiceList ul li {
  margin-top: 8px;
}

.BC-BackInStockFilters--Popover .breakLine {
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/back-in-stock.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,YAAY,EAAE,wCAAwC;EACtD,2BAA2B,EAAE,4CAA4C;AAC3E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB","sourcesContent":[".BC-Page__BackInStock-Subscription .pfs-feature-lock-card,\n.BC-Page__BackInStock-Settings .pfs-feature-lock-card {\n  margin: unset;\n  padding: 40px 93px;\n}\n\n.BC-BISSettingsGuide .Polaris-Banner {\n  margin-bottom: 32px;\n}\n.BC-BISSettingsGuide .Polaris-Banner .Polaris-Link {\n  display: inline-flex;\n  gap: 2px;\n  color: #2c6ecb;\n}\n\n.BC-BISSettingsGuide .setup-content .non-action .Polaris-Icon,\n.BC-BISSettingsGuide .Polaris-Banner .Polaris-Icon {\n  margin: unset;\n  width: 15px;\n  height: 15px;\n}\n\n.BC-BISSettingsGuide .Polaris-Grid {\n  gap: 20px;\n}\n\n.BC-BISSettingsGuide .setup-content .action,\n.BC-BISSettingsGuide .setup-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-BISSettingsGuide .setup-content .non-action {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__BackInStock-Settings .Polaris-Card .title .Polaris-Label__Text,\n.BC-Page__BackInStock-Settings .Polaris-Card .title {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Back in stock - settings */\n.BC-Page__BackInStock-Settings .Polaris-Card .title .badge-info {\n  background-color: #e0f0ff;\n  border-radius: 8px;\n  padding: 2px 8px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  color: #00527c;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.BC-Page__BackInStock-Settings .Polaris-PageActions {\n  border-top: none;\n}\n\n.BC-Page__BackInStock-Settings .BC-Toggle-Switch .tooltip {\n  margin-top: 4px;\n  margin-left: 4px;\n}\n\n.BC-Page__BackInStock-Settings .Polaris-Tabs__Panel {\n  padding: 16px 0;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .pfs-feature-lock-card img {\n  width: 160px;\n  height: auto;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .pfs-feature-lock-card {\n  padding: 92px 112px;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle p:first-child {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle .tag {\n  padding: 2px 8px;\n  background: #cdfee1;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: #0c5132;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .automation-status-toggle .tag-off {\n  background: #d6d6d6;\n  color: #616161;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages .header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages .header > p {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages .header > div {\n  border-radius: 8px;\n  padding: 2px 8px;\n  background-color: #e0f0ff;\n  color: #00527c;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages .upgrade {\n  color: #2c6ecb;\n  align-items: center;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages .upgrade:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.BC-Page__BackInStock-Settings .notification-usages .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n  width: 14px;\n  height: 14px;\n  margin-left: 2px;\n  margin-top: 3px;\n}\n\n.BC-Page__BackInStock-Settings .usages-exceed .header > div {\n  background-color: #fedad9;\n  color: #8e1f0b;\n}\n\n.BC-Page__BackInStock-Settings .usages-exceed .warning {\n  display: flex;\n  gap: 8px;\n  padding: 10px 16px;\n  background-color: #fffbf3;\n  border-radius: 8px;\n}\n\n.BC-Page__BackInStock-Settings .usages-exceed .warning > div {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.BC-Page__BackInStock-Settings .usages-exceed .warning .Polaris-Button {\n  background-color: #ffc96b;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n}\n\n.BC-Page__BackInStock-Settings .usages-exceed .warning .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .title {\n  padding: 18px 16px;\n  font-weight: 500;\n  font-size: 16px;\n  border-bottom: 1px solid #e1e3e5;\n}\n.BC-Page__BackInStock-Settings .customize-email .settings {\n  display: flex;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .settings .domain-field {\n  display: flex;\n  gap: 16px;\n  align-items: start;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .settings .domain-field .action {\n  display: flex;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .settings .domain-field > div:first-child {\n  width: 100%;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .Polaris-Tabs__Panel {\n  padding: 16px;\n}\n.BC-Page__BackInStock-Settings .customize-email .Polaris-Tabs__Panel:has(.customize-email-tab) {\n  padding-right: 0;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .Polaris-Scrollable {\n  scrollbar-width: none;\n}\n\n/* Show scrollbar only on hover */\n.BC-Page__BackInStock-Settings .customize-email .Polaris-Scrollable:hover {\n  scrollbar-width: thin;\n  scroll-margin-left: 2px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview {\n  width: 50%;\n  border-left: 1px solid #e1e3e5;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template {\n  padding: 12px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template > div {\n  padding: 17px 12px;\n  border-radius: 6px;\n  background-color: #f1f1f1;\n  position: relative;\n  height: 100%;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template img {\n  width: 177px;\n  height: auto;\n  margin-top: 16px;\n  margin-bottom: 20px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template > div > div:first-child {\n  background-color: #ffff;\n  padding: 24px 20px;\n  text-align: center;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template > div h2 {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 28px;\n  margin-top: 8px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template > div > div:first-child p {\n  font-size: 10px;\n  line-height: 15px;\n  margin-top: 16px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-box-mail-action {\n  width: 100%;\n  position: absolute;\n  bottom: 6px;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-box-mail-action > div {\n  padding: 4px 8px;\n  border: 1px solid #98c6cd;\n  background-color: #ebf9fc;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-between;\n  box-shadow: 0px 0px 2px 0px #00000033;\n  gap: 50px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-box-mail-action > div > p:nth-child(2) {\n  color: #2c6ecb;\n  cursor: pointer;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template > div .btn {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .preview-template > div .btn > div {\n  padding: 8px 16px;\n  border-radius: 2px;\n  margin-top: 16px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 16px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .label {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 4px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .waring-from-address {\n  padding: 16px;\n  border-radius: 4px;\n  background: #fff5ea;\n  border: 1px solid #e1b878;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .label > p:nth-child(2) {\n  cursor: pointer;\n  color: #2c6ecb;\n  height: 20px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .row {\n  display: flex;\n  gap: 12px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .row > div {\n  width: 50%;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .customize-email-tab .divider {\n  margin: 4px 0;\n}\n\n.BackInStock-LiquidVariablesModal {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.BackInStock-LiquidVariablesModal > div {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n  align-items: center;\n}\n\n.BC-Page__BackInStock-Settings\n  .customize-email\n  .BC-Page__BackInStock-Settings\n  .customize-email\n  textarea {\n  background-color: #fafbfb;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .html-template {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 12px;\n  height: 486px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .html-template .preview-box-mail-action {\n  z-index: 50;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .html-template textarea {\n  border: 1px solid #d0d0d0;\n  background-color: #fafbfb;\n  max-height: 455px;\n  height: 455px;\n  font-family: Monaco;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .domain-settings {\n  min-height: 486px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-warning {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 6px;\n  color: #916a00;\n}\n.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-success {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 6px;\n  color: #008060;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-warning .Polaris-Icon,\n.BC-Page__BackInStock-Settings .customize-email .domain-settings .notify-success .Polaris-Icon {\n  margin: unset;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__BackInStock-Settings .customize-email .domain-settings > div {\n  background-color: #fafbfb;\n  padding: 12px 16px;\n}\n\n.BIS-DomainTable {\n  padding: 8px 12px;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BIS-DomainTable .row {\n  display: flex;\n  gap: 4px;\n}\n\n.BIS-DomainTable .headings > p {\n  font-weight: 600;\n}\n\n.BIS-DomainTable .row > p {\n  width: calc(100% / 3);\n}\n\n.BC-Page__BackInStock-Settings .display-settings .tooltip {\n  margin-top: 7px !important;\n  margin-left: 8px;\n}\n\n.BC-Page__BackInStock-Settings .Polaris-Card__Section > .Polaris-TextStyle--variationSubdued {\n  margin-top: 4px;\n}\n\n.BC-Page__BackInStock-Settings .product-settings {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.BC-Page__BackInStock-Settings .product-settings .Polaris-Choice .tooltip {\n  margin-top: unset;\n}\n\n.BC-Page__BackInStock-Settings .product-settings .item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-Page__BackInStock-Settings .product-settings .item > div:nth-child(2) {\n  margin-left: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-Page__BackInStock-Settings .BC-Draggable__Tag {\n  padding-right: 0;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .title {\n  padding: 16px 20px;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__BackInStock-Settings .display-settings .content {\n  display: flex;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .content > div {\n  width: 50%;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .content > div:first-child {\n  border-right: var(--p-border-divider);\n}\n\n.BC-Page__BackInStock-Settings .preview > div,\n.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel {\n  padding: 16px 20px;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel {\n  min-height: 441px;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel .row {\n  display: flex;\n  gap: 8px;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel .row > div {\n  flex: 1;\n}\n\n.BC-Page__BackInStock-Settings .display-settings .Polaris-Tabs__Panel > div {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.BC-Page__BackInStock-Settings .Polaris-Tabs__Wrapper {\n  padding: 0 20px;\n  padding-top: 4px;\n}\n\n.BC-Page__BackInStock-Settings .preview > div:nth-child(1) {\n  border-bottom: var(--p-border-divider);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__BackInStock-Settings .preview .view {\n  padding: 16px;\n  width: 100%;\n  height: 100%;\n}\n\n.BC-Page__BackInStock-Settings .preview .view > div {\n  background-color: #f1f1f1;\n  border-radius: 8px;\n  width: 100%;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .button-settings {\n  position: relative;\n  padding: 23px 14px 0;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .btn-preview-container {\n  position: absolute;\n  right: 0;\n  top: 40px;\n  min-width: 44px;\n  min-height: 280px; /* The height of the btn-preview */\n}\n\n.BC-Page__BackInStock-Settings .preview .view .btn-preview-inline {\n  border-radius: 4px;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .btn-preview-inline,\n.BC-Page__BackInStock-Settings .preview .view .btn-preview {\n  text-align: center;\n  padding: 12px 20px;\n  min-width: 280px; /* Width becomes height after rotation */\n}\n\n.BC-Page__BackInStock-Settings .preview .view .btn-preview {\n  position: absolute;\n  top: 0;\n  right: 44px;\n  border-radius: 4px 4px 0 0;\n  transform: rotate(-90deg);\n  max-width: 334px;\n  height: 44px; /* Height becomes width after rotation */\n  transform-origin: top right; /* Ensure rotation doesn't affect position */\n}\n\n.BC-Page__BackInStock-Settings .preview .view .btn {\n  width: 100%;\n  border-radius: 4px;\n  padding: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #cccccc;\n  background: #fafafa;\n  color: #cecece;\n}\n\n.BC-Page__BackInStock-Settings .preview .blocks {\n  padding: 24px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.BC-Page__BackInStock-Settings .preview .view > div > div {\n  background-color: #ffff;\n  min-height: 360px;\n}\n\n.BC-Page__BackInStock-Settings .preview .blocks .col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form {\n  padding: 10px 15px;\n}\n.BC-Page__BackInStock-Settings .preview .view .signup-form > div {\n  border-radius: 8px;\n  height: auto;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-content {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  pointer-events: none;\n}\n\n.BC-Page__BackInStock-Settings .preview .signup-form .modal-content .phone-input-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-Page__BackInStock-Settings .preview .signup-form .modal-content .phone-input-preview > div {\n  display: flex;\n  align-items: center;\n  border: 1px solid #c9cccf;\n  border-radius: 4px;\n  padding: 8px 12px;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form > div > div:nth-child(1) {\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-title {\n  font-size: 18px;\n  line-height: 28px;\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  height: auto;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-title > p {\n  width: 70%;\n  max-width: 70%;\n  height: 100%;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form .modal-title .Polaris-Icon {\n  margin: unset;\n  width: 20px;\n  height: 20px;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .signup-form .action {\n  width: 100%;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 4px;\n  margin-top: 20px;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .confirmation-message {\n  padding: 0 17px;\n  height: auto;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .confirmation-message .blocks {\n  padding: 0 40px 18px;\n}\n\n.BC-Page__BackInStock-Settings .selectedColor {\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  margin-left: 0.75rem;\n  cursor: pointer;\n}\n.BC-Page__BackInStock-Settings .preview .view .confirmation-message .notify-banner {\n  margin: 0 20px;\n  padding: 12px 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.BC-Page__BackInStock-Settings .preview .view .confirmation-message .notify-banner .icon {\n  border-radius: 100%;\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .button-large.isSelected .Polaris-Button,\n.BC-Page__BackInStock-Settings .notification-settings .button-large:hover .Polaris-Button {\n  border: 1px solid #2c6ecb;\n}\n\n.BC-Page__BackInStock-Settings\n  .notification-settings\n  .button-large:hover\n  .Polaris-Button.Polaris-Button--disabled {\n  border-color: var(--p-border-disabled);\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .button-large .Polaris-Button {\n  padding: 1rem;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .button-large .button-content {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .button-large .button-content .Polaris-Badge {\n  padding: 2px 8px;\n  height: fit-content;\n}\n\n.BC-Page__BackInStock-Settings\n  .notification-settings\n  .Polaris-Card__Section\n  .notification-setting-steps {\n  margin-bottom: 0.75rem;\n  padding: 0.75rem;\n  background: var(--p-background, #f6f6f7);\n  border-radius: 0.25rem;\n}\n\n.BC-Page__BackInStock-Settings\n  .notification-settings\n  .Polaris-Card__Section\n  .notification-setting-steps:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .notification-setting-steps p:first-child {\n  margin-bottom: 0.25rem;\n}\n\n.BC-Page__BackInStock-Settings .notification-settings .notification-setting-steps ul {\n  margin-block-start: 0;\n  margin-block-end: 0;\n  padding-inline-start: 1.5rem;\n}\n\n.blocks .rectangle-lg {\n  width: 227px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #f0f0f0;\n}\n\n.blocks .rectangle {\n  border-radius: 4px;\n  background-color: #f0f0f0;\n}\n\n.blocks .group {\n  display: flex;\n  gap: 8px;\n}\n\n.blocks .rounded {\n  border-radius: 20px;\n  background-color: #f0f0f0;\n}\n\n.blocks .rounded-md {\n  width: 80px;\n  height: 36px;\n}\n\n.blocks .rectangle-lg {\n  width: 227px;\n  height: 36px;\n}\n\n.blocks .rectangle-mn {\n  height: 14px;\n  width: 227px;\n}\n\n.blocks .rectangle-md {\n  width: 103px;\n  height: 28px;\n}\n\n.blocks .rectangle-sm {\n  width: 71px;\n  height: 20px;\n}\n\n/* Back in stock - subscriptions */\n.BC-Page__BackInStock-Subscription .Polaris-DataTable__Cell--actions .Polaris-Icon svg {\n  fill: var(--p-icon);\n}\n\n.BC-Page__BackInStock-Subscription .Polaris-Tabs__Panel .Polaris-Card {\n  margin-top: 24px;\n}\n\n.BC-Page__BackInStock-Subscription .Polaris-Tabs__Wrapper {\n  width: 100%;\n}\n\n.BC-Page__BackInStock-Subscription .Polaris-DataTable__Cell--subscriber {\n  max-width: 22%;\n}\n\n.BC-Page__BackInStock-Subscription .Polaris-DataTable__Cell > p {\n  word-break: break-all;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n.BC-Page__BackInStock-Subscription .Polaris-Tabs__TabContainer:first-child {\n  max-width: 120px;\n}\n\n.BC-Page__BackInStock-Subscription .filter-days {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.BC-Page__BackInStock-Subscription .filter-days .Polaris-Icon {\n  margin: unset;\n}\n\n.BC-Page__BackInStock-Subscription .subscribed-actions,\n.BC-Page__BackInStock-Subscription .submissions-actions {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n\n.BC-Page__BackInStock-Subscription\n  .list-submissions\n  .Polaris-DataTable__Cell--header\n  .Polaris-Icon {\n  margin: unset;\n  cursor: pointer;\n}\n\n.BC-BIS__FilterDays {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 2px;\n}\n\n.BC-Page__BackInStock-Subscription .BC-Filters {\n  padding: 20px;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__BackInStock-Subscription nav {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n}\n\n.BC-Page__BackInStock-Subscription .BC-Filters__TagsContainer {\n  padding-top: 10px;\n}\n\n/* ------ submissions ------- */\n.BC-EmptySearch__BackInStockSubscription {\n  text-align: center;\n  padding: 80px 112px;\n}\n\n.BC-EmptySearch__BackInStockSubscription img {\n  max-width: 45px;\n  height: auto;\n  margin-bottom: 16px;\n}\n\n.BC-Page__BackInStock-NewSubscriber .Polaris-Page-Header__Row {\n  padding: 20px 0;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__BackInStock-NewSubscriber .Polaris-Header-Title > div {\n  display: flex;\n  gap: 16px;\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 600;\n  align-items: center;\n}\n\n.BC-Page__BackInStock-NewSubscriber .Polaris-Page > div:nth-child(2) {\n  margin-top: 24px;\n}\n.BC-Page__BackInStock-NewSubscriber .Polaris-Header-Title > div button {\n  background-color: unset;\n}\n\n.BC-Page__BackInStock-NewSubscriber .Polaris-Card__Header {\n  border-bottom: var(--p-border-divider);\n  padding: 16px 20px;\n}\n\n.BC-Page__BackInStock-NewSubscriber .BC-SelectedProductsField .product-item {\n  border: 0.1rem dashed #e1e3e5;\n  border-radius: 8px;\n  align-items: center;\n  text-align: center;\n  padding: 8px 16px;\n}\n\n.BC-Page__BackInStock-NewSubscriber .BC-SelectedProductsField .product-item__Action {\n  display: flex;\n}\n\n.BC-Page__BackInStock-NewSubscriber .BC-SelectedProductsField .Polaris-Icon svg {\n  fill: #8c9196;\n}\n\n/* ------ products ------- */\n.BC-BISSubscription--Filters {\n  display: flex;\n  gap: 8px;\n}\n\n.BC-BISSubscription--Filters > .search {\n  flex: 1;\n}\n\n.BC-BackInStockFilters--Popover .Polaris-ChoiceList .Polaris-ChoiceList__Title {\n  font-weight: 500;\n}\n\n.BC-BackInStockFilters--Popover .Polaris-ChoiceList ul li {\n  margin-top: 8px;\n}\n\n.BC-BackInStockFilters--Popover .breakLine {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
